import React from 'react';
import { Configure } from 'react-instantsearch/dom';
import { connect } from 'react-redux';
import {
  getNumericFilterValuesForSelectedTopic,
  getNumericFilterValuesForSelectedProgress,
} from 'selectors/learn/search';

const ApplyFilters = ({ idsForSelectedTopic, idsForSelectedProgress }) => (
  <Configure
    /**
     * Filter hits based on values of numeric attributes.
     *
     * If you specify multiple filters, they are interpreted as a conjunction
     * (AND). If you want to use a disjunction (OR), use a nested array.
     * For more info:
     * https://www.algolia.com/doc/api-reference/api-parameters/numericFilters/
     */
    numericFilters={[idsForSelectedTopic, idsForSelectedProgress]}
  />
);

const mapStateToProps = state => ({
  idsForSelectedTopic: getNumericFilterValuesForSelectedTopic(state),
  idsForSelectedProgress: getNumericFilterValuesForSelectedProgress(state),
});

export default connect(mapStateToProps)(ApplyFilters);
